<div *ngIf="isInValid">
    <div class="col-md-12">
        <h2 style="text-align: center;margin-top: 30vh;color:red">
            {{messageError | uppercase}}
        </h2>
    </div>
</div>
<div *ngIf="!isInValid">
    <section class="content cus-body" style="margin-top: 20px;">
        <div class="card">
            <div class="card-body">
                <section class="row">
                    <div class="container-fluid">
                        <div class="row mb-2">
                            <div class="col-md-6">
                                <app-bread-crum [breadCrumbs]="breadCrumbs"></app-bread-crum>
                            </div>
                            <div class="col-md-6">
                                <button class="btn-feature btn btn-outline-success btn-sm" (click)="search()">
                                    <i class="fas fa-search"></i>&nbsp;Tìm kiếm</button>
                                <!-- <button class="btn-feature btn btn-outline-info btn-sm" (click)="printData()">
                                    <i class="fa fa-print" aria-hidden="true"></i>&nbsp;In</button> -->
                                <button class="btn-feature btn btn-outline-success btn-sm" (click)="exportToExcel()">
                                    <i class="fas fa-file-excel"></i>&nbsp;Xuất Excel</button>
                                <button class="btn-feature btn btn-outline-warning btn-sm" (click)="toggle()">
                                    <i class="fa fa-caret-down"></i> &nbsp;Ẩn/ hiện bộ lọc</button>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    </section>

    <section class="content cus-body" *ngIf="isOpen" [@toggleBox]="isOpen ? 'open' : 'closed'">
        <div class="card">
            <div class="card-body">
                <form class="form-horizontal" [formGroup]="filter">
                    <div class="row">
                        <div class="col-md-4">
                            <label class="col-md-12 " style="margin-top: 10px;">Hệ</label>
                            <ng-select formControlName="ID_he" placeholder="Chọn hệ" (change)="filterBySelect()">
                                <ng-option [value]="0">Tất cả</ng-option>
                                <ng-option *ngFor="let item of listGeneration" [value]="item.ID_he">{{item.Ten_he}}
                                </ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-4">
                            <label class="col-md-12 " style="margin-top: 10px;">Khoa</label>
                            <ng-select formControlName="ID_khoa" placeholder="Chọn khoa" (change)="filterBySelect()">
                                <ng-option [value]="0">Tất cả</ng-option>
                                <ng-option *ngFor="let item of listDepartment" [value]="item.ID_khoa">{{item.Ten_khoa}}
                                </ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-4">
                            <label class="col-md-12 " style="margin-top: 10px;">Khóa học</label>
                            <ng-select formControlName="Khoa_hoc" placeholder="Chọn khóa" (change)="filterBySelect()">
                                <ng-option [value]="0">Tất cả</ng-option>
                                <ng-option *ngFor="let item of listSchoolYear" [value]="item">{{item}}
                                </ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-4">
                            <label class="col-md-12 " style="margin-top: 10px;">Lớp</label>
                            <ng-select formControlName="ID_lop" placeholder="Chọn lớp">
                                <ng-option [value]="0">Tất cả</ng-option>
                                <ng-option *ngFor="let item of listClass" [value]="item.ID_lop">{{item.Ten_lop}}
                                </ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-4">
                            <label class="col-md-12 " style="margin-top: 10px;">Năm học</label>
                            <ng-select formControlName="ID_kh" placeholder="Chọn năm" (change)="filterBySelectByYear()">
                                <ng-option *ngFor="let item of listYear" [value]="item.ID_kh">
                                    Năm học: {{item.Nam_hoc}} (Từ ngày {{item.Tu_ngay | date: 'dd/MM/yyyy'}} đến ngày
                                    {{item.Den_ngay | date: 'dd/MM/yyyy'}})
                                </ng-option>
                            </ng-select>
                        </div>
                        <div class="col-md-4">
                            <label class="col-md-12 " style="margin-top: 10px;">Tuần</label>
                            <ng-select formControlName="ID_kh_tuan" placeholder="Chọn tuần">
                                <ng-option *ngFor="let item of listWeek" [value]="item.ID_kh_tuan">
                                    Tuần thứ: {{item.Tuan_thu}} (Từ ngày {{item.Tu_ngay | date: 'dd/MM/yyyy'}} đến ngày
                                    {{item.Den_ngay | date: 'dd/MM/yyyy'}})
                                </ng-option>
                            </ng-select>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </section>
    <!-- <div *ngFor="let day of columnTitle |  paginate: { itemsPerPage: 2, currentPage: q}">
        {{day}}
    </div>
    
    <pagination-controls (pageChange)="q = $event"></pagination-controls> -->

    <section class="content cus-body">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div *ngIf="!(listTimeTable?.length > 0)" class="col-md-12">
                        <p style="text-align: center;" class="empty-data">Không có lịch học nào !</p>
                    </div>
                    <div class="col-md-12">
                        <div class="row mb-2">
                            <div class="col-md-6">
                                <pagination-controls previousLabel="Trước" nextLabel="Tiếp"
                                    (pageChange)="onTableDataChange($event)">
                                </pagination-controls>
                            </div>
                            <div class="col-md-6">
                                <select style="float: right;" (change)="changePage()" [(ngModel)]="itemPerPage">
                                    <option *ngFor="let item of pageSizesExport" [value]="item.value">{{item.name}}
                                    </option>
                                </select>
                                <p style="float: right;">Số bản ghi&nbsp;&nbsp;</p>
                            </div>
                        </div>
                    </div>
                    <table *ngFor="let data of listTimeTable |  paginate: { 
                        itemsPerPage: itemPerPage,
                        currentPage: page,
                        totalItems: count
                    }" class="table table-bordered">
                        <thead>
                            <tr>
                                <th [ngStyle]="{'width.px': day.width}" *ngFor="let day of columnTitle" scope="col">
                                    <div>
                                        <p style="text-align: center;line-height: 5px;">{{day.name | uppercase}}</p>
                                        <div *ngIf="day.date">
                                            <p style="text-align: center;">({{day.date | date: 'dd/MM/yyyy'}})
                                            <p>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style="word-wrap: break-word;" rowspan="3">{{data.Ten_lop}}</td>
                                <td>
                                    <div>
                                        Sáng
                                    </div>
                                </td>
                                <td style="word-wrap: break-word;" *ngFor="let c of data.LichLop">
                                    <div *ngFor="let d of columnDay">
                                        <div *ngIf="c.Thu == d">
                                            <div *ngFor="let scheduleDay of c.LichNgay">
                                                <div *ngIf="scheduleDay.Ca_hoc == 0">
                                                    <div *ngFor="let subject of scheduleDay.LichCa"
                                                        class="subject-wrap">
                                                        <p class="subject">{{subject.Ten_phong}}</p>
                                                        <p class="subject">{{subject.Ten_mon}} ({{subject.So_tiet}}
                                                            tiết)
                                                        </p>
                                                        <p class="subject">{{subject.Ho_ten}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Chiều</td>
                                <td style="word-wrap: break-word;" *ngFor="let c of data.LichLop">
                                    <div *ngFor="let d of columnDay">
                                        <div *ngIf="c.Thu == d">
                                            <div *ngFor="let scheduleDay of c.LichNgay">
                                                <div *ngIf="scheduleDay.Ca_hoc == 1">
                                                    <div *ngFor="let subject of scheduleDay.LichCa"
                                                        class="subject-wrap">
                                                        <p class="subject">{{subject.Ten_phong}}</p>
                                                        <p class="subject">{{subject.Ten_mon}} ({{subject.So_tiet}}
                                                            tiết)
                                                        </p>
                                                        <p class="subject">{{subject.Ho_ten}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Tối</td>
                                <td style="word-wrap: break-word;" *ngFor="let c of data.LichLop">
                                    <div *ngFor="let d of columnDay">
                                        <div *ngIf="c.Thu == d">
                                            <div *ngFor="let scheduleDay of c.LichNgay">
                                                <div *ngIf="scheduleDay.Ca_hoc == 2">
                                                    <div *ngFor="let subject of scheduleDay.LichCa"
                                                        class="subject-wrap">
                                                        <p class="subject">{{subject.Ten_phong}}</p>
                                                        <p class="subject">{{subject.Ten_mon}} ({{subject.So_tiet}}
                                                            tiết)
                                                        </p>
                                                        <p class="subject">{{subject.Ho_ten}}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>
</div>